let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    // Isolate subscribers: one throwing callback (a brand widget, the A/B sync,
    // the sale bar…) must not abort the others or throw back into the
    // publisher — product-form.js publishes cartUpdate mid add-to-cart, before
    // the drawer render.
    subscribers[eventName].forEach((callback) => {
      try {
        callback(data);
      } catch (e) {
        console.error(e);
      }
    });
  }
}
